// components/Navbar.jsx
import React from 'react';
import './Navbar.css'; // Add this CSS file

const Navbar = () => {
  return (
    <nav className="navbar">
      <img 
        src="https://univ.sitare.org/static/media/logo.5b7a3e74824b376d41e8.png" 
        alt="Logo" 
        className="navbar-logo" 
      />
      <span className="navbar-text">Application Portal</span>
    </nav>
  );
};

export default Navbar;
